import React, { useState } from "react";
import {
  Button,
  Modal,
  Form,
  Input,
  Collapse,
  Table,
  Select,
  Upload,
  Switch,
  Space,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";

const { Panel } = Collapse;
const { Option } = Select;
const ServiceManagement = () => {
  const [isDiscount, setIsDiscount] = useState(false);
  const handleSwitchChange = (checked) => {
    setIsDiscount(checked);
  };
  const [serviceManagementData, setServiceManagementData] = useState([
    {
      key: 1,
      servicename: "X-Ray",
      price: 400,
      discount: "40 %",
      status: "Available",
    },
    {
      key: 2,
      servicename: "Dental X-Ray",
      price: 400,
      discount: "40 %",
      status: "Available",
    },
    {
      key: 3,
      servicename: "Mommograghy",
      price: 400,
      discount: "40 %",
      status: "Unavailable",
    },
    {
      key: 4,
      servicename: "Bone Density Scan",
      price: 400,
      discount: "40 %",
      status: "Unavailable",
    },
    {
      key: 5,
      servicename: "Ultrasound",
      price: 400,
      discount: "40 %",
      status: "Unavailable",
    },
    {
      key: 6,
      servicename: "CT scan",
      price: 400,
      discount: "40 %",
      status: "Unavailable",
    },
    {
      key: 7,
      servicename: "MRI",
      price: 400,
      discount: "40 %",
      status: "Unavailable",
    },
    {
      key: 8,
      servicename: "PET Scab",
      price: 400,
      discount: "40 %",
      status: "Unavailable",
    },
    {
      key: 9,
      servicename: "Fluoroscopy",
      price: 400,
      discount: "40 %",
      status: "Unavailable",
    },
    {
      key: 10,
      servicename: "Angiography",
      price: 400,
      discount: "40 %",
      status: "Unavailable",
    },
  ]);
  const serviceManagementCol = [
    {
      title: "Service Name",
      dataIndex: "servicename",
      key: "servicename",
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "Discount %",
      dataIndex: "discount",
      key: "discount",
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
    },
    {
      title: "Actual Price",
      key: "actual price",
      dataIndex: "actualPrice",
    },
    {
      title: "Timing",
      key: "timing",
      dataIndex: "timing",
    },
    // ,
    // {
    //   title: "Action",
    //   key: "action",
    //   render: (_, record) => (
    //     <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
    //       <Button
    //         type="primary"
    //         disabled={record.status === "Available"} // Disable if status is "Unavailable"
    //         // onClick={() => handleAdd(record)}
    //       >
    //         Add
    //       </Button>
    //       <Button
    //         type="primary"
    //         danger
    //         disabled={record.status === "Unavailable"} // Disable if status is "Unavailable"
    //         // onClick={() => handleRemove(record)}
    //       >
    //         Remove
    //       </Button>
    //     </div>
    //   ),
    // },
  ];
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        console.log("Form Values:", values);
        form.resetFields(); // Reset the form fields
        setIsModalVisible(false); // Close the modal
      })
      .catch((errorInfo) => {
        console.error("Validation Failed:", errorInfo);
      });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  return (
    <div className="vendor-diagnostic-service-management">
      <Table
        title={() => (
          <h2 style={{ margin: 0 }}>Diagnostic Imaging Center - Services</h2>
        )}
        columns={serviceManagementCol}
        dataSource={serviceManagementData}
        pagination={{
          pageSize: 5, // Show 5 rows per page
        }}
      />
      <Button type="primary" onClick={showModal}>
        Add Your Service
      </Button>
      <Modal
        title="Fill the Form"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Submit"
        cancelText="Cancel"
      >
        <Form
          form={form}
          layout="vertical"
          name="userForm"
          initialValues={{ remember: true }}
        >
          <Form.Item
            label="Service Name"
            name="servicename"
            rules={[
              { required: true, message: "Please provide your service name" },
            ]}
          >
            <Input placeholder="Enter Service Name" />
          </Form.Item>
          <Form.Item
            label="Price"
            name="price"
            rules={[{ required: true, message: "Please fill the price" }]}
          >
            <Input placeholder="Enter Price of the service" />
          </Form.Item>
          <Form.Item label="Is there a discount?">
            <Space>
              <Switch onChange={handleSwitchChange} />
              <span>{isDiscount ? "Yes" : "No"}</span>
            </Space>
          </Form.Item>

          {isDiscount && (
            <Form.Item
              label="Discount Amount (%)"
              name="discountAmount"
              rules={[
                {
                  required: true,
                  message: "Please enter the discount amount!",
                },
                {
                  type: "number",
                  min: 1,
                  max: 100,
                  message: "Discount must be between 1% and 100%",
                },
              ]}
            >
              <Input
                placeholder="Enter discount percentage"
                type="number"
                style={{ width: "100%" }}
              />
            </Form.Item>
          )}
        </Form>
      </Modal>
    </div>
  );
};

export default ServiceManagement;
